import keyMirror from 'keymirror';

export const episodesActionTypes = keyMirror({
	GET_EPISODES_REQUEST: null,
	GET_EPISODES_SUCCESS: null,
	GET_EPISODES_ERROR: null,
	CREATE_EPISODE_REQUEST: null,
	CREATE_EPISODE_SUCCESS: null,
	CREATE_EPISODE_ERROR: null,
});
